// Injects a JSON-LD <script> block into <head> for the lifetime of the mounting component.
// Multiple calls with different `keyId` values can coexist. On unmount the tag is removed.
import { useEffect } from "react";

export default function useJsonLd(keyId, data) {
  useEffect(() => {
    if (!data) return;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.dataset.jsonldKey = keyId;
    el.text = JSON.stringify(data);
    // Remove any stale tag with the same key before appending
    document.querySelectorAll(`script[data-jsonld-key="${keyId}"]`).forEach((n) => n.remove());
    document.head.appendChild(el);
    return () => {
      try { document.head.removeChild(el); } catch { /* already gone */ }
    };
  }, [keyId, JSON.stringify(data)]); // eslint-disable-line react-hooks/exhaustive-deps
}
